import React from 'react';
import PropTypes from 'prop-types';
import { Input } from '@glu/form-components';
import MobileGridContext from '../logic/MobileGridContext';
import * as actions from '../logic/actions';

const FuzzyFilter = ({ column }) => {
  const gridContext = React.useContext(MobileGridContext);
  const { field, headerName } = column;
  const unAppliedFilterState = gridContext?.unAppliedFilterState || [];
  const filterValues = unAppliedFilterState.filter((filter) => filter.field === field);
  const displayValue = filterValues[0]?.filterData?.filter;
  return (
    <Input
      type="text"
      labelText={` `}
      value={displayValue}
      onChange={(e) => {
        const { value } = e.target;
        actions.updateUnappliedFilters({
          gridContext,
          payload: {
            name: field,
            value: {
              field,
              nameDisplay: headerName,
              criteriaDisplay: `Contains ${value}`,
              id: `${field}-contains-Contains ${value}`,
              filterData: {
                type: 'contains',
                filter: value,
                filterType: 'text',
                variant: 'fuzzy'
              }
            }
          }
        });
      }}
      name={`${field}-filter`}
    />
  );
};

FuzzyFilter.propTypes = {
  column: PropTypes.shape({
    field: PropTypes.string,
    headerName: PropTypes.string
  }).isRequired
};

export default FuzzyFilter;
